import { $, $$, sliderConfig, isTablet } from '@utils';
import Swiper from 'swiper';
import { Navigation, Scrollbar, A11y, FreeMode, Grid } from 'swiper/modules';
import datalayerPushGeneric from '@utils/DataLayerPushGeneric';

function init() {
  if (!$('[data-au-logos]')) return;

  const slidersArray = [];

  addEventListeners(slidersArray);
  addModifierClass();
  buildSlider(slidersArray, isTablet.matches);
}

function addEventListeners(slidersArray) {
  isTablet.addEventListener('change', () => {
    slidersArray.forEach((slider) => slider.destroy());
    buildSlider(slidersArray, isTablet.matches);
  });

  if ($('[data-au-logo-link]')) {
    $$('[data-au-logo-link]').forEach((link) => {
      link.addEventListener('click', dataLayerLogos);
    });
  }
}

function numOfLogos(module) {
  return module.querySelectorAll('[data-au-logos-elem]').length;
}

function addModifierClass() {
  $$('[data-au-logos]').forEach((module) => {
    if (numOfLogos(module) === 4 || numOfLogos(module) > 6) {
      module.classList.add('au-logos--flex');
    }
  });
}

function buildSlider(slidersArray, isTablet) {
  $$('[data-au-logos]').forEach((slider) => {
    if ((isTablet && numOfLogos(slider) > 1) || numOfLogos(slider) > 6) {
      const logoSlider = new Swiper(slider, {
        modules: [Navigation, Scrollbar, A11y, FreeMode, Grid],
        ...sliderConfig,
        breakpoints: {
          1024: {
            slidesPerView: 2,
            grid: {
              rows: 2,
            },
          },
          1360: {
            slidesPerView: 3,
            grid: {
              rows: 2,
            },
          },
        },
      });

      slidersArray.push(logoSlider);
    }
  });
}

function dataLayerLogos(e) {
  const alt = e.target.querySelector('img').getAttribute('alt');

  datalayerPushGeneric(e, null, 'clickEnlace', null, alt);
}

export default { init };
